module.exports = __webpack_public_path__ + "static/img/3.6618548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/3.jpg
// module id = lccp
// module chunks = 12